<mat-drawer-container>
	<mat-drawer #drawer [mode]="mode" [position]="position" (openedChange)="onToggle.emit($event)">
		<ng-content select="[formField]" />
	</mat-drawer>
	<mat-drawer-content>
		<button
			class="toggleBtn"
			[class.open]="drawer.opened"
			(click)="toggle()"
			color="accent"
			mat-icon-button
			[matBadgeOverlap]="true"
			[matBadge]="iconBadge"
			matBadgeSize="small"
			matBadgeColor="warn"
		>
			<mat-icon [fontIcon]="icon.fontIcon" [fontSet]="icon.fontSet" />
		</button>
	</mat-drawer-content>
</mat-drawer-container>
